});

function closemodal(e){
	var $modal = jQuery(e).closest('.modal');
	$modal.removeClass('modal-active')
	if ($modal.hasClass('gallery-modal')) {
		var iframe = $modal.find('iframe')[0];
		iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		iframe.contentWindow.postMessage('{"event":"command","method":"pause","args":""}', '*');
	}
}